import { Model, ModelType } from './Model';

export interface RoleType extends ModelType {
    name: string;
}

export const Role = Model<RoleType>('Role', { endpoint: 'roles' })`
    id:int;
`;

export enum ROLES {
    ADMIN = 5,
    DEVELOPER = 6,
    SALESMAN = 7,
    CUSTOMER = 10,
    OPS = 11,
    FACTORY_ADMIN = 14,
    FACTORY_USER = 15,
    WHOLESALER = 18,
    WHOLESALER_ADMIN = 19,
}
